module.exports = __webpack_public_path__ + "static/contentBlockBack-a277dc1e2c8468e824f8ab1323ee5b0c.png";